import { render, staticRenderFns } from "./mailings-create-page.vue?vue&type=template&id=acbc1e70&"
import script from "./mailings-create-page.vue?vue&type=script&lang=js&"
export * from "./mailings-create-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports